import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SpotifySettings from './pages/SpotifySettings';
import TwitchSettings from './pages/TwitchSettings';
import WidgetGenerator from './pages/WidgetGenerator';
import Queue from './pages/Queue';
import BotSettings from './pages/BotSettings';
import Admin from './pages/Admin';
import Widget from './pages/Widget';
import ChangePassword from './pages/ChangePassword';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/widget/:uuid" element={<Widget />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings/spotify" element={<SpotifySettings />} />
            <Route path="/settings/twitch" element={<TwitchSettings />} />
            <Route path="/widget-generator" element={<WidgetGenerator />} />
            <Route path="/queue" element={<Queue />} />
            <Route path="/bot" element={<BotSettings />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer position="bottom-right" theme="dark" />
    </AuthProvider>
  );
}
